/*
 * @Author: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @Date: 2025-12-10 09:34:34
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2025-12-30 10:24:16
 */
import React, { useEffect, useState } from 'react'
import { RecommendKeywordItem, RecommendSlotData } from '../../types'

type RecommendKeywordsProps = {
  recommendSlotData: RecommendSlotData | null
}

const RecommendKeywords: React.FC<RecommendKeywordsProps> = ({
  recommendSlotData
}) => {
  const [visibleKeywords, setVisibleKeywords] = useState<
    RecommendKeywordItem[]
  >([])

  useEffect(() => {
    const recommendKeywords = recommendSlotData?.keywords ?? []
    if (recommendKeywords.length === 0) {
      setVisibleKeywords([])
      return
    }

    const tempSpan = document.createElement('span')
    tempSpan.style.position = 'absolute'
    tempSpan.style.visibility = 'hidden'
    tempSpan.style.whiteSpace = 'nowrap'
    tempSpan.style.fontSize = '12px'
    tempSpan.style.fontFamily = getComputedStyle(document.body).fontFamily
    tempSpan.className = 'pfv2-recommend-item'
    document.body.appendChild(tempSpan)

    const MAX_WIDTH = 350
    const GAP = 8
    const visibleItems: RecommendKeywordItem[] = []
    let totalWidth = 0

    for (let i = 0; i < recommendKeywords.length; i++) {
      const item = recommendKeywords[i]
      tempSpan.textContent = item.word
      const itemWidth = tempSpan.offsetWidth
      const widthWithGap = i === 0 ? itemWidth : itemWidth + GAP

      if (totalWidth + widthWithGap <= MAX_WIDTH) {
        totalWidth += widthWithGap
        visibleItems.push(item)
      } else {
        break
      }
    }

    document.body.removeChild(tempSpan)
    setVisibleKeywords(visibleItems)
  }, [recommendSlotData])

  if (!recommendSlotData?.onSelect || visibleKeywords.length === 0) {
    return null
  }

  return (
    <>
      <span className="pfv2-divider">|</span>
      <div className="pfv2-recommend">
        <span className="pfv2-recommend-label">猜你想搜</span>
        <div className="pfv2-recommend-list">
          {visibleKeywords.map((item, index) => (
            <span
              key={`${item.word}-${index}`}
              className="pfv2-recommend-item"
              onClick={() => recommendSlotData.onSelect(item)}
            >
              {item.word}
            </span>
          ))}
        </div>
      </div>
    </>
  )
}

export default RecommendKeywords
